import { render, staticRenderFns } from "./AttachmentsInnerSection.vue?vue&type=template&id=65cfcce1&scoped=true&"
import script from "./AttachmentsInnerSection.vue?vue&type=script&lang=js&"
export * from "./AttachmentsInnerSection.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentsInnerSection.vue?vue&type=style&index=0&id=65cfcce1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cfcce1",
  null
  
)

export default component.exports